import map from './parser-map';
import helpers from '../helpers';

class Tournament {
  constructor(rawTournament) {
    this.id = rawTournament[map.tournament.id];
    this.idSport = rawTournament[map.tournament.idSport];
    this.idCategory = rawTournament[map.tournament.idCategory];
    this.name = rawTournament[map.tournament.name];
    this.shortName = rawTournament[map.tournament.shortName] || this.name;
    this.position = parseInt(rawTournament[map.tournament.position], 10) || helpers.maxInt;
    this.topTournament = !!rawTournament[map.tournament.topTournament];
    this.providerId = rawTournament[map.tournament.providerId];
    this.parent = rawTournament[map.tournament.parent];
    this.active = true;
    this.showMatches = false;
  }
}

export default Tournament;
